import { createDataWidget } from "@/widgets/common/createDataWidget";
import { mockFetch } from "@/widgets/common/mockFetch";
import { generateInkTrend } from "./mock";
import type { InkTrendPoint } from "./types";

/**
 * Widget state via the shared factory (D11): thunk + slice + selectors in one
 * declaration — replaces the hand-written `thunks.ts`/`slice.ts`/`selectors.ts`
 * trio. Swapping in CubeJS replaces `mockFetch` with a real fetcher.
 */
export const inkTrendChart = createDataWidget<InkTrendPoint>({
  name: "inkTrendChart",
  fetcher: mockFetch(() => generateInkTrend()),
});
